<template>
  <el-popover
    v-if="isEnabled && hasRoute"
    :placement="placement"
    :trigger="trigger"
    :open-delay="openDelay"
    popper-class="consignment-link-popover"
  >
    <ConsignmentPopover :consignment="consignment" />

    <router-link
      slot="reference"
      :to="to"
      :target="target"
    >
      <slot>{{ label }}</slot>
    </router-link>
  </el-popover>

  <router-link
    v-else-if="hasRoute"
    :to="to"
    :target="target"
  >
    <slot>{{ label }}</slot>
  </router-link>

  <span v-else>
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
import ConsignmentPopover from '@/components/Popovers/Consignment'

export default {
  name: 'ConsignmentLink',
  components: {
    ConsignmentPopover
  },
  props: {
    consignment: {
      type: Object,
      required: true
    },
    enabled: {
      type: Boolean,
      required: false,
      default: null
    },
    routeName: {
      type: String,
      default: 'freight-consignments-v3-consignment'
    },
    placement: {
      type: String,
      default: 'right'
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    target: {
      type: String,
      required: false,
      default: null
    },
    openDelay: {
      type: Number,
      default: 200
    }
  },
  computed: {
    hasRoute () {
      return !!this.$_.get(this.consignment, 'id')
    },
    to () {
      return {
        name: this.routeName,
        params: { consignmentId: this.consignment.id }
      }
    },
    label () {
      return this.$_.get(this.consignment, 'con_full', '-')
    },
    preferenceEnabled () {
      return this.$store.getters['configuration/layout/consignmentLinkPopoverEnabled']
    },
    isEnabled () {
      return typeof this.enabled === 'boolean' ? this.enabled : this.preferenceEnabled
    }
  },
  created () {
    if (!this.consignment.items || !this.consignment.trackings || this.$_.isEmpty(this.consignment.items) || this.$_.isEmpty(this.consignment.trackings)) {
      this.consignment.refresh(builder => {
        builder.include = ['items', 'trackings']
      })
    }
  }
}
</script>

<style>
.consignment-link-popover {
  width: auto !important;
  max-width: calc(100vw - 32px);
}
</style>
